<template>
  <div style="margin: 0 16px">
    <div class="content-input" style="margin: -16px 0 24px">
<!--      <div class="content-input-item">-->
<!--        <label>记录类型：</label>-->
<!--        <el-select v-model="state" placeholder="Select" style="width: 7em">-->
<!--          <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--          </el-option>-->
<!--        </el-select>-->
<!--      </div>-->
      <div class="content-input-item">
        <span v-if="pageType == 3">回复/被回复时间：</span>
        <el-select v-else v-model="timeType" placeholder="Select" style="width: 10em; margin-right: 4px">
          <el-option v-for="item in (pageType==1?timeTypeArray_1:timeTypeArray_2)" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>

        <DatePickerRange title="" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
      </div>
      <div class="content-input-item">
        <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
      </div>
      <div class="content-input-item">
        <ElButtons type="primary" icon="search" @click="getPage(true)"> 查询 </ElButtons>
      </div>
    </div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        border
        @cell-click="toggleSelection"
        v-loading="listLoading"
    >
      <el-table-column label="头像" width="140">
        <template #default="scope">
          <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
        </template>
      </el-table-column>
      <el-table-column property="" label="基本信息" width="300">
        <template #default="scope">
          <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth" :isDialog="true"/>
          <p>学历：<span v-if="scope.row.authEdu">{{scope.row.authEdu.education==1?'初中':scope.row.authEdu.education==2?'中专/职高/技校':scope.row.authEdu.education==3?'高中':scope.row.authEdu.education==4?'大专':scope.row.authEdu.education==5?'本科':scope.row.authEdu.education==6?'硕士':scope.row.authEdu.education==7?'博士':scope.row.authEdu.education==8?'博士后':''}}</span></p>
          <p>学校：<span v-if="scope.row.authEdu">{{scope.row.authEdu.schoolName}}</span></p>
          <p>学历认证：<span v-if="scope.row.authEdu">{{scope.row.authEdu.eduState == 2?'已认证':'未认证'}}</span></p>
          <p>身份认证：<span v-if="scope.row.identityAuth">{{scope.row.identityAuth.overallAuthState == 2?'已认证':'未认证'}}</span></p>
        </template>
      </el-table-column>
      <el-table-column property="sendDateTime" label="发送密信时间" v-if="pageType != 2" />
      <el-table-column property="receiveDateTime" label="收到密信时间" v-if="pageType != 1" />
      <el-table-column property="" label="是否回复" v-if="pageType != 3">
        <template #default="scope">
          <p>{{scope.row.replyDateTime?'是':'否'}}</p>
        </template>
      </el-table-column>
      <el-table-column property="replyDateTime" :label="pageType == 3?'回复/被回复时间':'回复时间'" />
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api'
import { getChatSecretUserList } from '@/api/url'
import UserInfoList from "@/components/resume/UserInfoList";
import SearchComponents from "@/components/SearchComponents";
import ImgViewer from "@/assets/js/imageViewer";
import DatePickerRange from '../../../components/DatePickerRange_30'
export default {
  name: "GreetingDateNum",
  components: { UserInfoList, SearchComponents, DatePickerRange },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      pageType: this.value.pageType,

      timeTypeArray_1: [
        {label: '被回复时间', value: 1},
        {label: '发送时间', value: 2},
      ],
      timeTypeArray_2: [
        {label: '回复时间', value: 1},
        {label: '收到时间', value: 2},
      ],
      timeType: 1,


      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '昵称', value : 2},
        {label : '用户ID', value : 3},
        {label : '用户日志', value : 4},
        {label : '身份证号', value : 5},
        {label : '实名', value : 6},
        {label : '自我介绍', value : 7},
      ],
      searchType: 1,
      searchValue: '',

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

      //注册/进入时间
      startTime: '',
      endTime: '',
      isChecked: false,

      chatSecretStartTime: '',
      chatSecretEndTime: '',

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['userId'] = this.userId;
      param['pageType'] = this.pageType;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['startTime'] = this.timeType == 1?this.startTime:'';
      param['endTime'] = this.timeType == 1?this.endTime:'';
      param['chatSecretStartTime'] = this.timeType == 2?this.startTime:'';
      param['chatSecretEndTime'] = this.timeType == 2?this.endTime:'';
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChatSecretUserList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(row) {
      let imgList = []
      imgList.push(row.headImg.headImg)
      ImgViewer.open({
        imgList: imgList
      })
    },

    toggleSelection(row, column, cell, event) {

    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
